import type { NodeSelection } from '@frontend/pages/dashboard/types';

interface DashboardNavSectionProps {
  selected: NodeSelection;
  homeEcosystemId: string;
  canSeeSystemAdmin: boolean;
  canSeeRealmAdmin: boolean;
  canSeeEcosystemAdmin: boolean;
  canSeeProjectAdmin: boolean;
  onSelectHome: () => void;
  onSelectSystemAdmin: () => void;
  onSelectRealmAdmin: () => void;
  onSelectEcosystemAdmin: () => void;
  onSelectProjectAdmin: () => void;
}

export default function DashboardNavSection({
  selected,
  homeEcosystemId,
  canSeeSystemAdmin,
  canSeeRealmAdmin,
  canSeeEcosystemAdmin,
  canSeeProjectAdmin,
  onSelectHome,
  onSelectSystemAdmin,
  onSelectRealmAdmin,
  onSelectEcosystemAdmin,
  onSelectProjectAdmin,
}: DashboardNavSectionProps) {
  const linkClass = (active: boolean) =>
    `tree-dashboard-quick-link tree-dashboard-quick-link-button${active ? ' active' : ''}`;

  return (
    <div className="tree-dashboard-sidebar-section">
      <div className="tree-dashboard-sidebar-title">Dashboard Navigation</div>
      <div className="tree-dashboard-quick-links">
        <button
          type="button"
          className={linkClass(
            selected.kind === 'ecosystem' && selected.ecosystemId === homeEcosystemId
          )}
          onClick={onSelectHome}
        >
          Home
        </button>
        {canSeeSystemAdmin ? (
          <button
            type="button"
            className={linkClass(selected.kind === 'admin-system')}
            onClick={onSelectSystemAdmin}
          >
            System Admin
          </button>
        ) : null}
        {canSeeRealmAdmin ? (
          <button
            type="button"
            className={linkClass(selected.kind === 'admin-realm')}
            onClick={onSelectRealmAdmin}
          >
            Realm Admin
          </button>
        ) : null}
        {canSeeEcosystemAdmin ? (
          <button
            type="button"
            className={linkClass(selected.kind === 'admin-ecosystem')}
            onClick={onSelectEcosystemAdmin}
          >
            Ecosystem Admin
          </button>
        ) : null}
        {canSeeProjectAdmin ? (
          <button
            type="button"
            className={linkClass(selected.kind === 'admin-project')}
            onClick={onSelectProjectAdmin}
          >
            Project Admin
          </button>
        ) : null}
      </div>
    </div>
  );
}
